import React from "react";
import { HelpIndicator } from "@jsq/ds/core";
import { buttonWrapperDiv } from "./style_vanilla.css";

type ButtonWrapperProps = {
  children: React.ReactNode;
  tooltip?: string;
  id?: string;
  disabled?: boolean;
};

export const ButtonWrapper: React.FC<ButtonWrapperProps> = ({
  children,
  tooltip,
  id,
  disabled,
}: ButtonWrapperProps) => {
  return tooltip && disabled ? (
    <HelpIndicator content={tooltip} id={id}>
      <div className={buttonWrapperDiv}>{children}</div>
    </HelpIndicator>
  ) : (
    <>{children}</>
  );
};
